import { render, staticRenderFns } from "./CoursewareCanvasBlock.vue?vue&type=template&id=3f43cf61&scoped=true&"
import script from "./CoursewareCanvasBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareCanvasBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareCanvasBlock.vue?vue&type=style&index=0&id=3f43cf61&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f43cf61",
  null
  
)

export default component.exports